import React from "react";
import { ProviderIcon } from "../../../shared/ProviderIcon";
import { providerDisplayLabel } from "../../../shared/providerIcons";
import { PROVIDER_ORDER } from "../providerMap";
import { hasSignalCoverage } from "../strategyShape";
import { SectionLabel } from "./shared";

export default function ProviderConsensusCard({ strategy, embedded = false }) {
	const filteredSignals = strategy.cross_provider_signals;
	const providerSpecific = filteredSignals.filter((s) => s.coverage_count === 1);
	const providerSpecificByProvider = PROVIDER_ORDER.map((p) => ({
		provider: p,
		signals: providerSpecific.filter((s) => hasSignalCoverage(s, p)),
	})).filter((g) => g.signals.length > 0);

	const body = (
		<div className="monitoring__analysis-strategy-consensus-section">
			<p className="monitoring__analysis-strategy-consensus-heading monitoring__analysis-strategy-consensus-heading--specific">
				Provider Specific Emphasis
			</p>
			<div className="monitoring__analysis-strategy-consensus-specific">
				{providerSpecificByProvider.map(({ provider, signals: sigs }) => (
					<p
						key={provider}
						className="monitoring__analysis-strategy-consensus-specific-row mb-0"
					>
						<span
							className="monitoring__analysis-strategy-consensus-provider-icon"
							title={providerDisplayLabel(provider)}
							aria-label={providerDisplayLabel(provider)}
						>
							<ProviderIcon provider={provider} size={16} />
						</span>
						<span>{sigs.map((s) => s.name).join(", ")}</span>
					</p>
				))}
				{providerSpecificByProvider.length === 0 && (
					<p className="text-muted mb-0">None.</p>
				)}
			</div>
		</div>
	);

	if (embedded) return body;

	return (
		<div className="monitoring__analysis-strategy-card monitoring__analysis-strategy-row-card monitoring__analysis-strategy-row-card--consensus monitoring__analysis-strategy-consensus-card">
			<div className="monitoring__analysis-strategy-card-head monitoring__analysis-strategy-consensus-card-head">
				<SectionLabel>Provider Consensus</SectionLabel>
			</div>
			<div className="monitoring__analysis-strategy-card-body monitoring__analysis-strategy-consensus">
				{body}
			</div>
		</div>
	);
}
